import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { CollegeEvent, CollegeEventList } from "@/models";

const state = {
  collegeEvent: new CollegeEvent(),
  collegeListEvent: new CollegeEventList(),
  collegeEvents: [],
  collegeTeamEvents: [],
  collegeListEvents: [],
  collegeEventLoading: false,
  collegeEventsLoading: false,
  meta: {},
  collegeEventsLimited: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
